module.exports = __webpack_public_path__ + "static/img/home-footer-logo.40311ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home-footer-logo.png
// module id = J0mk
// module chunks = 1